import React from "react";
import { FaStar } from "react-icons/fa";

const RatingStars = ({ value = 0, onChange, size = "text-base", readonly = false }) => {
  return (
    <div className="flex items-center gap-1" role={readonly ? "img" : "radiogroup"} aria-label="Rating">
      {[1, 2, 3, 4, 5].map((star) => {
        const active = star <= value;
        return (
          <button
            key={star}
            type="button"
            disabled={readonly}
            onClick={() => onChange && onChange(star)}
            className={`${size} transition-colors ${active ? "text-amber-400" : "text-gray-300"} ${readonly ? "cursor-default" : "hover:text-amber-300"}`}
            aria-label={`${star} star`}
          >
            <FaStar />
          </button>
        );
      })}
    </div>
  );
};

export default RatingStars;
